import { motion } from "framer-motion";
import styles from "./home_2.module.css";
import Container from "../ui/container";
import LongText from "../ui/LongText";
import img1 from "../../assets/images/home_2/Asset 6@2x.png";
import img2 from "../../assets/images/home_2/Asset 7@2x.png";
import img3 from "../../assets/images/home_2/Asset 9@2x.png";
import img4 from "../../assets/images/home_2/Asset 9@2x.png";
import img5 from "../../assets/images/home_2/Asset 10@2x.png";
import img6 from "../../assets/images/home_2/Asset 11@2x.png";
import img7 from "../../assets/images/home_2/Asset 12@2x.png";
import img8 from "../../assets/images/home_2/Asset 21@2x.png";
import img9 from "../../assets/images/home_2/Asset 20@2x.png";
import img10 from "../../assets/images/home_2/Asset 14@2x.png";
import img11 from "../../assets/images/home_2/Asset 15@2x.png";
import img12 from "../../assets/images/home_2/Asset 16@2x.png";
import img13 from "../../assets/images/home_2/Asset 27@2x.png";
import img14 from "../../assets/images/home_2/Asset 28@2x.png";
import img15 from "../../assets/images/home_2/Asset 26@2x.png";
import img16 from "../../assets/images/home_2/Asset 8@2x.png";
import img17 from "../../assets/images/home_2/Asset 33@2x.png";
import img18 from "../../assets/images/home_2/Asset 34@2x.png";
import img19 from "../../assets/images/home_2/Asset 35@2x.png";
import { useTranslation } from "../../context/LanguageContext";

function Home2() {
  const initial = {
    opacity: 0,
    scale: 0.5,
  };
  const animate = {
    opacity: 1,
    scale: 1,
  };
  const transition = {
    duration: 0.5,
  };
  const { translate } = useTranslation();

  return (
    <section className="bg-[#fffaf3] pt-12 pb-8">
      <Container>
        <div className="relative">
          {/* absolute */}
          <motion.div
            className="absolute top-[10px] right-[-158px]"
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
          >
            <img src={img1} alt="img" width={211} height={84} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[10px] left-[-140px]"
          >
            <img src={img2} alt="img" width={211} height={84} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[176px] right-[100px]"
          >
            <img src={img3} alt="img" width={188} height={103} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[176px] right-[100px]"
          >
            <img src={img4} alt="img" width={188} height={103} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[389px] right-[-126px]"
          >
            <img src={img5} alt="img" width={98} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[247px] left-[50px]"
          >
            <img src={img6} alt="img" width={136} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[772px] left-[-65px]"
          >
            <img src={img7} alt="img" width={128} height={122} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[548px] right-[-110px]"
          >
            <img src={img8} alt="img" width={337} height={453} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1078px] left-[-92px]"
          >
            <img src={img9} alt="img" width={415} height={361} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1366px] right-[278px]"
          >
            <img src={img10} alt="img" width={128} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1183px] right-[-98px]"
          >
            <img src={img11} alt="img" width={128} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1393px] left-[-154px]"
          >
            <img src={img12} alt="img" width={128} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1523px] left-[40px]"
          >
            <img src={img13} alt="img" width={128} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1632px] right-[220px]"
          >
            <img src={img14} alt="img" width={128} height={130} />
          </motion.div>
          <motion.div
            initial={initial}
            whileInView={animate}
            transition={transition}
            viewport={{ once: true }}
            className="absolute top-[1356px] right-[-110px]"
          >
            <img src={img15} alt="img" width={345} height={321} />
          </motion.div>
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          {/* main */}
          <div id="about" className="mb-[47px]">
            <motion.div
              initial={{ opacity: 0, y: -40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <img
                className="mx-auto"
                src={img16}
                alt="bg_pink"
                width={427}
                height={274}
              />
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, amount: 0.8 }}
              className="text-center text-[98px] leading-[1] font-semibold text-black mt-10 mb-0.5"
            >
              {translate("home_2.heading")}
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, y: -40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.8 }}
              className=" max-w-[1213px] mx-auto text-center mt-6"
            >
              <LongText
                className="font-bricolage text-[33px]"
                text={translate("home_2.description")}
              ></LongText>
            </motion.div>
          </div>
          {/* item   */}
          <div className="max-w-[1335px] mx-auto flex flex-col items-start">
            {[
              {
                label: "home_2.item1_title",
                text: "home_2.item1_desc",
              },
              {
                label: "home_2.item2_title",
                text: "home_2.item2_desc",
              },
              {
                label: "home_2.item3_title",
                text: "home_2.item3_desc",
              },
            ].map((i, index) => {
              const item = {
                label: translate(i.label),
                text: translate(i.text),
              };
              if (index === 0) {
                return <Item1 key={index} item={item} />;
              } else if (index === 1) {
                return <Item2 key={index} item={item} />;
              } else if (index === 2) {
                return <Item3 key={index} item={item} />;
              }
              return <></>;
            })}
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Home2;
const Item1 = ({ item }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.8 }}
      className="ml-[58px] w-fit"
    >
      <div className="relative w-fit -ml-[60px] -mb-[67px]">
        <img src={img17} alt="img" width={361} height={137} />
        <h3 className="text-[54px] text-[#C5BAD8] absolute top-0 left-0 py-[30px] w-full text-center">
          {item.label}
        </h3>
      </div>
      <div className="max-w-[966px] bg-[#C5BAD8] rounded-[70px] pt-[67px] pr-[54px] pb-[54px] pl-[94px]">
        <LongText
          className="text-white font-bricolage text-[26px] leading-[1.2]"
          text={item.text}
        />
      </div>
    </motion.div>
  );
};
const Item2 = ({ item }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.8 }}
      className="self-end w-fit mt-[90px] -mr-[56px]"
    >
      <div className="relative w-fit -ml-[50px] -mb-[67px]">
        <img src={img18} alt="img" width={742} height={130} />
        <h3 className="text-[54px] text-[#C5BAD8] absolute top-0 left-0 py-[30px] w-full text-center">
          {item.label}
        </h3>
      </div>
      <div className="max-w-[1060px] bg-[#C5BAD8] rounded-[70px] pt-[70px] pr-[100px] pb-[67px] pl-[116px]">
        <LongText
          className="text-white font-bricolage text-[26px] leading-[1.2]"
          text={item.text}
        />
      </div>
    </motion.div>
  );
};
const Item3 = ({ item }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.8 }}
      className="ml-[205px] w-fit mt-[83px]"
      id="contact"
    >
      <div className="relative w-fit -ml-[30px] -mb-[67px]">
        <img src={img19} alt="img" width={658} height={133} />
        <h3 className="text-[54px] text-[#C5BAD8] absolute top-0 left-0 py-[30px] w-full text-center">
          {item.label}
        </h3>
      </div>
      <div className="max-w-[748px] bg-[#C5BAD8] rounded-[70px] pt-[70px] pr-[54px] pb-[48px] pl-[94px]">
        <LongText
          className={`text-white font-bricolage text-[26px] text-center ${styles.address}`}
          text={item.text}
        />
      </div>
    </motion.div>
  );
};
